import { ArrowRight, BookOpen, Compass, CircleQuestionMark as HelpCircle, Layers } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
export default function OutdoorLivingCta() {
  return <section id="outdoorlivingcta" data-nav="light" className="bg-background text-foreground py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="overflow-hidden rounded-2xl border border-border bg-card shadow-lg">
          <div className="grid grid-cols-1 lg:grid-cols-12 items-stretch">
            {/* Image Column */}
            <div className="relative min-h-[320px] lg:min-h-full lg:col-span-5 overflow-hidden">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/outdoor_living_deck_remodel.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/outdoor_living_deck_remodel.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/outdoor_living_deck_remodel.png-wvc-sizes" alt="Custom cedar and composite outdoor deck remodel with integrated pergola and dining space" loading="lazy" decoding="async" className="h-full w-full object-cover object-center transition-transform duration-500 hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent lg:hidden" />
            </div>

            {/* Content Column */}
            <div className="flex flex-col justify-between p-8 sm:p-12 lg:col-span-7 lg:p-14">
              <div>
                <div className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-primary mb-3">
                  <span className="h-1.5 w-1.5 rounded-full bg-primary" />
                  Brookhaven Outdoor Living
                </div>

                <h2 className="font-serif text-3xl font-normal tracking-tight text-foreground sm:text-4xl">
                  Expand your living area into the open air
                </h2>

                <p className="mt-4 text-base leading-relaxed text-muted-foreground sm:text-lg">
                  Whether you envision an elevated multi-tier deck, an all-season screened porch, or an integrated outdoor kitchen, we design and build outdoor additions engineered for lasting Atlanta living.
                </p>

                <div className="mt-8 flex flex-wrap items-center gap-4">
                  <Button asChild size="lg" className="rounded-md font-medium text-base px-6">
                    <Link to="/ContactRequestAnEstimatePage">
                      Request an Estimate
                      <ArrowRight className="size-4" />
                    </Link>
                  </Button>
                </div>
              </div>

              <div className="mt-12 space-y-6 pt-6">
                <Separator />

                {/* Related Services Row */}
                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 text-sm">
                  <span className="font-medium text-foreground flex items-center gap-2">
                    <Layers className="size-4 text-primary" />
                    Related Services:
                  </span>
                  <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
                    <Link to="#" className="text-muted-foreground transition-colors hover:text-foreground underline-offset-4 hover:underline">
                      Outdoor Living
                    </Link>
                    <span className="text-border" aria-hidden="true">•</span>
                    <Link to="#" className="text-muted-foreground transition-colors hover:text-foreground underline-offset-4 hover:underline">
                      Home Additions
                    </Link>
                  </div>
                </div>

                {/* Planning Resources Links */}
                <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-muted-foreground pt-2">
                  <Link to="#" className="inline-flex items-center gap-1.5 transition-colors hover:text-foreground">
                    <BookOpen className="size-3.5 text-primary" />
                    Remodeling Cost Guide
                  </Link>
                  <Link to="#" className="inline-flex items-center gap-1.5 transition-colors hover:text-foreground">
                    <Compass className="size-3.5 text-primary" />
                    Planning Guide
                  </Link>
                  <Link to="#" className="inline-flex items-center gap-1.5 transition-colors hover:text-foreground">
                    <HelpCircle className="size-3.5 text-primary" />
                    Frequently Asked Questions
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}